export const APPLE_PAY_WINDOW_NAME = 'CASHIER-APPLE-PAY';

export const APPLE_PAY_METHOD_ID = 'SafeCharge ApplePay';
export const GOOGLE_PAY_METHOD_ID = 'SafeCharge GooglePay';
